import React from 'react';
import ReactDOM from 'react-dom';

const ModalComponent = ({ children, targetRootId }) => {
  const targetRoot = document.getElementById(targetRootId);
  return targetRoot ? ReactDOM.createPortal(children, targetRoot) : null;
};

export default ModalComponent;